(function() {
  var TOKEN = 'f611b9a1b6f3e781fc391626946f1b00';
  var cache = {};
  var timer = null;
  var applyInterval = null;

  function getShopDomain() {
    return (window.Shopify && window.Shopify.shop) ? window.Shopify.shop : window.location.hostname;
  }

  function applyValues() {
    document.querySelectorAll('.compare-cpp-placeholder').forEach(function(el) {
      var handle = el.dataset.printerHandle;
      if (!cache[handle]) return;
      var valueEl = el.querySelector('.cpp-badge__value');
      var target = valueEl || el;
      if (target.textContent.trim() === 'N/A') {
        target.textContent = cache[handle];
      }
    });
  }

  function fetchAndApply() {
    var placeholders = document.querySelectorAll('.compare-cpp-placeholder');
    if (!placeholders.length) return;

    var handles = [];
    placeholders.forEach(function(el) {
      var h = el.dataset.printerHandle;
      if (h && handles.indexOf(h) === -1) handles.push(h);
    });

    var query = '{ ' + handles.map(function(handle, i) {
      return 'pr' + i + ': productByHandle(handle: "' + handle + '") { compatibleToners: metafield(namespace: "custom", key: "compatible_toners") { references(first: 5) { nodes { ... on Product { variants(first: 1) { edges { node { price { amount } } } } pageYield: metafield(namespace: "custom", key: "page_yield") { value } } } } } }';
    }).join(' ') + ' }';

    fetch('https://' + getShopDomain() + '/api/2024-01/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': TOKEN
      },
      body: JSON.stringify({ query: query })
    })
    .then(function(r) { return r.ok ? r.json() : null; })
    .then(function(json) {
      if (!json || !json.data) return;
      handles.forEach(function(handle, i) {
        var node = json.data['pr' + i];
        var toners = (node && node.compatibleToners && node.compatibleToners.references && node.compatibleToners.references.nodes) ? node.compatibleToners.references.nodes : [];
        var bestCpp = Infinity;
        toners.forEach(function(toner) {
          var y = parseInt(((toner.pageYield || {}).value || '').replace(/[^0-9]/g, ''), 10) || 0;
          var edges = ((toner.variants || {}).edges || []);
          var p = parseFloat((edges[0] && edges[0].node && edges[0].node.price) ? edges[0].node.price.amount : 0);
          if (y > 0 && p > 0 && (p / y) < bestCpp) bestCpp = p / y;
        });
        if (bestCpp < Infinity) {
          cache[handle] = (bestCpp * 100).toFixed(1) + '\u00a2/page';
        }
      });
      applyValues();
      if (!applyInterval) {
        applyInterval = setInterval(function() {
          if (Object.keys(cache).length > 0) applyValues();
        }, 500);
        setTimeout(function() { clearInterval(applyInterval); }, 10000);
      }
    })
    .catch(function(err) { console.error('CPP error:', err); });
  }

  var observer = new MutationObserver(function() {
    applyValues();
    if (timer) clearTimeout(timer);
    timer = setTimeout(fetchAndApply, 300);
  });
  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('render-product-compare-modal', function() {
    setTimeout(fetchAndApply, 1500);
  });
})();